import { addDays, addYears, format, getYear } from 'date-fns';

export const tomorrowDate = addDays(new Date(), 1);
export const todayDateAdd20years = addYears(
  new Date(getYear(tomorrowDate), 11, 31),
  20,
);
export const frenchDate = 'dd/MM/yyyy';

export const displayDate = (date: string) => format(new Date(date), frenchDate);
